import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";

import MembershipPermission from "js/pages/MembershipPermission";
import PropertyDetails from "js/components/Properties/PropertyDetails/PropertyDetails";
import NotFound from "js/pages/NotFound";
import Configuration from "js/pages/Organization/Configuration";
import CreateOrganization from "js/pages/Organization/CreateOrganization";
import Members from "js/pages/Organization/Members";
import OrganizationReports from "js/pages/Organization/OrganizationReports";
import Properties from "js/pages/Organization/Properties";
import Tenants from "js/pages/Organization/Tenants";
import { QuotasOrderDetail, QuotasPage } from "js/pages/Quotas";

import permissions from "../utils/membershipPermissions";

const Organization = () => {
  const { organizationData } = useSelector(
    (state: any) => state.entities.organization,
  );
  const hasTenantModule = !!organizationData?.modules?.includes("tenant");
  const hasCreditHistModule =
    !!organizationData?.modules?.includes("credit_history");
  const hideQuotas = hasTenantModule && !hasCreditHistModule;

  return (
    <Routes>
      <Route path="create" element={<CreateOrganization />} />
      <Route
        path="members"
        element={
          <MembershipPermission requiredPermission={permissions.advisorManager}>
            <Members />
          </MembershipPermission>
        }
      />
      <Route
        path="credits"
        element={<Navigate to="/organizations/quotas" replace />}
      />
      <Route
        path="tenants"
        element={
          <MembershipPermission
            requiredPermission={permissions.organizationTenantCatalog}
          >
            <Tenants />
          </MembershipPermission>
        }
      />
      <Route
        path="properties/:propertyId/details"
        element={
          <MembershipPermission
            requiredPermission={permissions.organizationPropertyCatalog}
          >
            <PropertyDetails organizationScope={true} />
          </MembershipPermission>
        }
      />
      <Route
        path="properties"
        element={
          <MembershipPermission
            requiredPermission={permissions.organizationPropertyCatalog}
          >
            <Properties />
          </MembershipPermission>
        }
      />
      <Route
        path="reports"
        element={
          <MembershipPermission requiredPermission={permissions.tenantTracker}>
            <OrganizationReports />
          </MembershipPermission>
        }
      />
      <Route
        path="quotas"
        element={
          hideQuotas ? (
            <Navigate to="/" replace />
          ) : (
            <MembershipPermission
              requiredPermission={permissions.reportDistributor}
            >
              <QuotasPage />
            </MembershipPermission>
          )
        }
      />
      <Route
        path="quotas/orders/:orderId"
        element={
          hideQuotas ? (
            <Navigate to="/" replace />
          ) : (
            <MembershipPermission
              requiredPermission={permissions.reportDistributor}
            >
              <QuotasOrderDetail />
            </MembershipPermission>
          )
        }
      />
      <Route path="settings" element={<Configuration />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Organization;
